import type {Channel} from '@mattermost/types/channels';

/**
 * Определяет что в канале нет сообщений
 */
export function isChannelEmpty(channel: Channel) {
    return Boolean(channel && channel.last_root_post_at === 0);
}
